import Accolades from "components/Collections/Accolades";
import AllWaivers from "components/Collections/AllWaivers";
import AdminsCustomers from "components/Collections/AdminsCustomers";
import AdminsTickets from "components/Collections/AdminsTickets";
import BusinessCards from "components/Collections/BusinessCards";
import CashCheckFinancials from "components/Collections/CashCheckFinancials";
import CompletionCertificates from "components/Collections/CompletionCertificates";
import ComputerWaivers from "components/Collections/ComputerWaivers";
import Managers from "components/Collections/Managers";
import ManagersApproval from "components/Collections/ManagersApproval"
import CalendarLogModal from "components/Collections/CalendarLogModal";
import Copyables from "components/Collections/Copyables";
import CustomerSales from "components/Collections/CustomerSales";
import CustomerAvCenter from "components/Collections/CustomerAvCenter";
import Candidates from "components/Collections/Candidates";
import Customers from "components/Collections/Customers";
import DispatchCustomers from "components/Collections/DispatchCustomers";
import DispatcherScores from "components/Collections/DispatcherScores"
import EngineerCalendar from "components/Collections/EngineerCalendar";
import Engineers from "components/Collections/Engineers";
import EngineersTicketStatus from "components/Collections/EngineersTicketStatus";
import EngineerScores from "components/Collections/EngineerScores";
import FeedbackZones from "components/Collections/FeedbackZones";
import FeedbackResponses from "components/Collections/FeedbackResponses";
import AllFinancials from "components/Collections/AllFinancials";
import HelpDesks from "components/Collections/HelpDesks";
import HelpDeskTimeTracking from "components/Collections/HelpDeskTimeTracking"
import HelpDesksRandom from "components/Collections/HelpDesksRandom"
import HelpDeskAlerts from "components/Collections/HelpDeskAlerts"
import InactiveAvSubscriptions from "components/Collections/InactiveAvSubscriptions";
import AvUpcomingRenewals from "components/Collections/AvUpcomingRenewals";
import StripeAvUnmatched from "components/Collections/StripeAvUnmatched";
import AvRenewalDistributedKeys from "components/Collections/AvRenewalDistributedKeys";
import AutomatedEmails from "components/Collections/AutomatedEmails";
import KpiMetrics from "components/Collections/KpiMetrics";
import KpiScores from "components/Collections/KpiScores";
import Locations from "components/Collections/Locations";
import LogsCalendar from "components/Collections/LogsCalendar";
import LogsCustomer from "components/Collections/LogsCustomer";
import LogsCustomersLocations from "./LogsCustomersLocations";
import LogsFinancials from "components/Collections/LogsFinancials";
import LogsTicket from "components/Collections/LogsTicket";
import MainCalendar from "components/Collections/MainCalendar";
import MandatoryAntiVirusInspectionWaivers from "components/Collections/MandatoryAntiVirusInspectionWaivers";
import MandatoryDataBackupWaivers from "components/Collections/MandatoryDataBackupWaivers";
import MandatoryNetworkInspectionWaivers from "components/Collections/MandatoryNetworkInspectionWaivers";
import MandatoryHardDriveInspectionWaivers from "components/Collections/MandatoryHardDriveInspectionWaivers";
import Outstanding_Invoices from "components/Collections/Outstanding_Invoices";
import PendingFinancials from "components/Collections/PendingFinancials";
import PhoneLogs from "components/Collections/PhoneLogs";
import RecentlyBooked from "components/Collections/RecentlyBooked";
import RegionalPhoneLogs from "components/Collections/RegionalPhoneLogs";
import RefundAgreements from "components/Collections/RefundAgreements";
import UserPhoneLogs from "components/Collections/UserPhoneLogs";
import Regions from "components/Collections/Regions";
import Tickets from "components/Collections/Tickets";
import TicketsFinancialsSignatures from "components/Collections/TicketsFinancialsSignatures"
import TimeOff from "components/Collections/TimeOff";
import TimeTracking from "components/Collections/TimeTracking";
import Users from "components/Collections/Users";
import UsersActive from "components/Collections/UsersActive";
import FEAvailability from "components/Collections/FEAvailability";
import FELocationTable from "components/Collections/FELocationTable";
import StripeCharges from "components/Collections/StripeCharges";
import WorkOrders from "components/Collections/WorkOrders";
import AuditWorkOrders from "components/Collections/AuditWorkOrders";
import FieldEngineerWeeklyAudit from "components/Collections/FieldEngineerWeeklyAudit";
import Alerts from "components/Collections/Alerts";
import Reschedules from "components/Collections/Reschedules";
import DispatcherTimeTracking from "components/Collections/DispatcherTimeTracking";
import DispatcherDailyActivities from "components/Collections/DispatcherDailyActivities";
import DispatcherDailyGaps from "components/Collections/DispatcherDailyGaps";
import HelpDesksContacted from "components/Collections/HelpDesksContacted";
import HelpDesksContactedHistory from "components/Collections/HelpDesksContactedHistory";
import HelpDesksUnfiltered from "components/Collections/HelpDesksUnfiltered";
import DispatcherSelfTime from "components/Collections/DispatcherSelfTime";
import Videos from "components/Collections/Videos";
import Categories from "components/Collections/Categories";
import SubCategories from "components/Collections/SubCategories";
import Projects from "components/Collections/Projects";
import Scores from "components/Collections/Scores";
import ScoreName from "components/Collections/ScoreName";
import HighScores from "components/Collections/HighScores";
import AvKeys from "components/Collections/AvKeys";
import ScoresChart from "components/Collections/ScoresChart";
import ScoresChartLine from "components/Collections/ScoresChartLine";
import SchedulesComponent from "components/Collections/SchedulesComponent";
import AuthCodes from "components/Collections/AuthCodes";
import GapTimers from "components/Collections/GapTimers";
import FreshdeskMergeSubjects from "components/Collections/FreshdeskMergeSubjects";
import NewHires from "components/Collections/NewHires";
import HelpdeskScores from "components/Collections/Helpdesk_Scores";
import HiringScores from "components/Collections/Hiring_Scores";
import WosWorked from "components/Collections/WosWorked";
import PrefersSooner from "components/Collections/PrefersSooner";
import Refunds from "components/Collections/Refunds"
import ExecutiveCharts from "components/Collections/ExecutiveCharts";
import HiringTimeTracking from "components/Collections/HiringTimeTracking";
import ScheduleApprovals from "components/Collections/ScheduleApprovals";
import Financial_Approvals from "components/Collections/Financial_Approvals";
import Financial_Edits from "components/Collections/FinancialEdits";
import Financial_Final_Numbers from "components/Collections/Financial_Final_Numbers";
import Individual_Final_Numbers from "components/Collections/Individual_Final_Numbers";
import Individual_Invoices from "components/Collections/Individual_Invoices";
import HelpDesks7DayMissing from "./HelpDesks7DayMissing";
import IdleTasks from "./IdleTasks";
import IdleTasksClicked from "./IdleTasksClicked";
import DispatcherDailyWorkflow from "./DispatcherDailyWorkflow";
import DailyEtaBoard from "./DailyEtaBoard";
import FePerformance from "components/Collections/FePerformance";
import FeMetricThresholds from "components/Collections/FeMetricThresholds";
import MissingFinancialWorkflows from "components/Collections/MissingFinancialWorkflows";
import WoClearCodes from "components/Collections/WoClearCodes";

const Collections = {
	Accolades: Accolades,
	AdminsCustomers: AdminsCustomers,
	AdminsTickets: AdminsTickets,
	AvKeys: AvKeys,
	Alerts: Alerts,
	AllFinancials: AllFinancials,
	AllWaivers: AllWaivers,
	AuthCodes: AuthCodes,
	BusinessCards: BusinessCards,
	CalendarLogModal: CalendarLogModal,
	Candidates: Candidates,
	DailyEtaBoard: DailyEtaBoard,
	CashCheckFinancials: CashCheckFinancials,
	Categories: Categories,
	CompletionCertificates: CompletionCertificates,
	ComputerWaivers: ComputerWaivers,
	Copyables: Copyables,
	Customers: Customers,
	CustomerSales: CustomerSales,
	CustomerAvCenter: CustomerAvCenter,
	SchedulesComponent: SchedulesComponent,
	DispatcherScores: DispatcherScores,
	DispatchCustomers: DispatchCustomers,
	DispatcherDailyActivities: DispatcherDailyActivities,
	DispatcherDailyGaps: DispatcherDailyGaps,
	DispatcherDailyWorkflow: DispatcherDailyWorkflow,
	DispatcherSelfTime: DispatcherSelfTime,
	DispatcherTimeTracking: DispatcherTimeTracking,
	EngineerCalendar: EngineerCalendar,
	Engineers: Engineers,
	EngineersTicketStatus: EngineersTicketStatus,
	EngineerScores: EngineerScores,
	ExecutiveCharts: ExecutiveCharts,
	FeedbackZones: FeedbackZones,
	FeedbackResponses: FeedbackResponses,
	FEAvailability: FEAvailability,
	FePerformance: FePerformance,
	FeMetricThresholds: FeMetricThresholds,
	FELocationTable: FELocationTable,
	Financial_Approvals: Financial_Approvals,
	Financial_Edits: Financial_Edits,
	Financial_Final_Numbers: Financial_Final_Numbers,
	GapTimers: GapTimers,
	FreshdeskMergeSubjects: FreshdeskMergeSubjects,
	HelpDesks: HelpDesks,
	HelpDesks7DayMissing: HelpDesks7DayMissing,
	HelpDeskTimeTracking: HelpDeskTimeTracking,
	HelpDesksRandom: HelpDesksRandom,
	HelpDeskAlerts: HelpDeskAlerts,
	HelpDesksContacted: HelpDesksContacted,
	HelpDesksContactedHistory: HelpDesksContactedHistory,
	HelpDesksUnfiltered: HelpDesksUnfiltered,
	HelpdeskScores: HelpdeskScores,
	HiringScores: HiringScores,
	HiringTimeTracking: HiringTimeTracking,
	IdleTasks: IdleTasks,
	IdleTasksClicked: IdleTasksClicked,
	InactiveAvSubscriptions: InactiveAvSubscriptions,
	AvUpcomingRenewals: AvUpcomingRenewals,
	StripeAvUnmatched: StripeAvUnmatched,
	AvRenewalDistributedKeys: AvRenewalDistributedKeys,
	AutomatedEmails: AutomatedEmails,
	Individual_Final_Numbers: Individual_Final_Numbers,
	Individual_Invoices: Individual_Invoices,
	HighScores: HighScores,
	KpiMetrics: KpiMetrics,
	KpiScores: KpiScores,
	Locations: Locations,
	LogsCalendar: LogsCalendar,
	LogsFinancials: LogsFinancials,
	LogsCustomer: LogsCustomer,
	LogsCustomersLocations: LogsCustomersLocations,
	LogsTicket: LogsTicket,
	MainCalendar:MainCalendar,
	Managers: Managers,
	MissingFinancialWorkflows: MissingFinancialWorkflows,
	ManagersApproval: ManagersApproval,
	NewHires: NewHires,
	Projects: Projects,
	MandatoryAntiVirusInspectionWaivers: MandatoryAntiVirusInspectionWaivers,
	MandatoryDataBackupWaivers: MandatoryDataBackupWaivers,
	MandatoryNetworkInspectionWaivers: MandatoryNetworkInspectionWaivers,
	MandatoryHardDriveInspectionWaivers: MandatoryHardDriveInspectionWaivers,
	Outstanding_Invoices: Outstanding_Invoices,
	PendingFinancials: PendingFinancials,
	PhoneLogs: PhoneLogs,
	PrefersSooner: PrefersSooner,
	RecentlyBooked: RecentlyBooked,
	Refunds: Refunds,
	RefundAgreements: RefundAgreements,
	RegionalPhoneLogs: RegionalPhoneLogs,
	Regions: Regions,
	ScheduleApprovals: ScheduleApprovals,
	Scores: Scores,
	ScoresChart: ScoresChart,
	ScoresChartLine: ScoresChartLine,
	ScoreName: ScoreName,
	StripeCharges: StripeCharges,
	SubCategories: SubCategories,
	Reschedules: Reschedules,
	Tickets: Tickets,
	TicketsFinancialsSignatures: TicketsFinancialsSignatures,
	TimeTracking: TimeTracking,
	TimeOff: TimeOff,
	Users: Users,
	UsersActive: UsersActive,
	UserPhoneLogs: UserPhoneLogs,
	Videos: Videos,
	WoClearCodes: WoClearCodes,
	WorkOrders: WorkOrders,
	AuditWorkOrders: AuditWorkOrders,
	FieldEngineerWeeklyAudit: FieldEngineerWeeklyAudit,
	WosWorked: WosWorked,

};

export default Collections;

